import React from "react";
import { useModalContext } from "../../contexts/ModalContext/context";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import { AccDebugModal } from "../AccDebugModal";

import { Button } from "../../UI/Button";

export const AccDebugButton = () => {
  const { setIsOpen } = useModalContext();
  const { selectedNetworkId } = useSelectedNetworkContext();

  const handleClick = () => setIsOpen(true);
  return (
    <>
      <Button appearance="danger" isDisabled={!selectedNetworkId} onClick={handleClick}>
        Acc Debug
      </Button>
      <AccDebugModal />
    </>
  );
};
